import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'

const MAX_ANSWERS_LENGTH = 15

const poll_add_answer_validation_selector = questionId => createSelector(
	[ state => state.poll ],
	pollState => {
		const question = pollState.questions.find(question => question.id === questionId)
		const valid = (question.answers.length+1) <= MAX_ANSWERS_LENGTH
		return {
			valid,
			message: valid?null:localize('quiz_answers_limit'),
		}
	}
)

export default poll_add_answer_validation_selector
